export var PaymentMethodTypeEnum;
(function (PaymentMethodTypeEnum) {
    PaymentMethodTypeEnum["CREDIT_CARD"] = "credit_card";
    PaymentMethodTypeEnum["GIFT_CARD"] = "gift_card";
    PaymentMethodTypeEnum["APPLE_PAY"] = "apple_pay";
    PaymentMethodTypeEnum["GOOGLE_PAY"] = "google_pay";
    PaymentMethodTypeEnum["CASH"] = "cash";
})(PaymentMethodTypeEnum || (PaymentMethodTypeEnum = {}));
//# sourceMappingURL=PaymentMethodTypeEnum.js.map